module.exports = __webpack_public_path__ + "04_short_brown.cc8dc939.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/04_short_brown.png
// module id = C4dR
// module chunks = 0